import { FC, PropsWithChildren, ReactNode } from 'react';
import { Breakpoint } from '../../../../common/model/Breakpoint';
import { Grid } from '../../../layout/grid/Grid';
import { GridProps } from '../../../layout/grid/model/GridProps';
import { TextProps } from '../../../typography/model/TextProps';
import { useMediaQ } from '../../../../hooks/useMediaQ';
import { SxProps } from '../../../../common/system/SxProps';
import { ListTextColTitle } from './ListTextColTitle';

type Props = GridProps &
  PropsWithChildren & {
    textProps?: TextProps;
    title?: string;
    hideTitle?: boolean;
    sx?: SxProps;
    tooltipTitle?: ReactNode;
    requiredTitle?: boolean;
    displayAtBreakpoint?: Breakpoint;
  };

export const ListHeader: FC<Props> = ({
  displayAtBreakpoint = 'lg',
  requiredTitle,
  title,
  hideTitle,
  children,
  textProps,
  tooltipTitle,
  ...props
}) => {
  const displayBreakpointUp = useMediaQ(displayAtBreakpoint, 'up');
  const titleToUse = requiredTitle && title ? `${title}*` : title;
  return (
    <>
      {!hideTitle && displayBreakpointUp && (
        <Grid item {...props}>
          <ListTextColTitle tooltipTitle={tooltipTitle} noWrap={textProps?.noWrap} textProps={textProps}>
            {titleToUse || children}
          </ListTextColTitle>
        </Grid>
      )}
    </>
  );
};
